import { LocaleCode } from '../shared/i18n/locale/models/LocaleCode';

export const chatbotLanguages: Record<LocaleCode, string> = {
	'en-US': 'en',
	'es-US': 'es',
};
